import React from 'react';
import './UIX.css';

const UIX = () => {
  return (
    <div className="uix-container">
      <div className="uix-hero">
        <h1 className="uix-title">UI/UX Design Services</h1>
        <p className="uix-subtitle">
          We design intuitive, clean, and elegant interfaces that deliver an exceptional user experience — tailored for your business and users.
        </p>
      </div>

      <div className="uix-features">
        <div className="feature-card">
          <h3>Wireframing & Prototyping</h3>
          <p>Plan layouts, flows, and interactivity using modern tools like Figma and Adobe XD.</p>
        </div>
        <div className="feature-card">
          <h3>Design Systems</h3>
          <p>We create scalable design systems to keep your product UI consistent across all devices and platforms.</p>
        </div>
        <div className="feature-card">
          <h3>Mobile-First Approach</h3>
          <p>Your UI will look amazing and function perfectly across smartphones, tablets, and desktops.</p>
        </div>
        <div className="feature-card">
          <h3>UX Research</h3>
          <p>Understand user behavior, pain points, and goals — then turn those insights into better experiences.</p>
        </div>
      </div>

      <div className="uix-cta">
        <h2>Let’s Design Something Beautiful</h2>
        <p>Try our AI-powered quotation tool to get a personalized estimate and kickstart your next UI/UX project.</p>
        <button onClick={() => window.open('/project_prompt', '_blank')}>
          Generate Quotation
        </button>
      </div>
    </div>
  );
};

export default UIX;
